<template>
    <div>
        <div class="hero">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="hero-content">
                            <h1 class="display-4 font-weight-bold  text-white">Devices</h1>
                            <h4 class="font-weight-light  text-white">Your device details.</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-container class="bv-example-row" style="margin-bottom:64px">
            <b-card
                no-body
                img-src="/icons/icon-meterdog.png"
                img-alt="Image"
                img-top
            >

                <b-card-body>
                    <h4
                        v-if="!nameEdit"
                        @click="edit_name(true)"
                        style="
                            font-size: 2rem;
                            cursor: pointer;
                            width: fit-content;
                            text-align: center;
                            margin-left: auto;
                            margin-right: auto;
                            margin-bottom:1rem;
                        "
                        v-b-tooltip.hover.right title="Click me to change my name."
                    >{{model.device.name}}</h4>

                    <b-form @submit.prevent="save_name" v-else inline style="width:480px; margin:auto" class="mb-4">
                        <b-input style="width:240px; margin-left:120px; margin-right:10px" v-model="model.device.name"/>
                        <b-button
                            variant="primary"
                            style="margin-right:5px"
                            @click="save_name"
                            :disabled="edit_buttons_disabled"
                        >Save</b-button>
                        <b-button variant="outline-dark" @click="edit_name(false)" :disabled="edit_buttons_disabled">X</b-button>
                    </b-form>
                    <b-card-sub-title class="mb-5">{{model.device.device_type_desc}}</b-card-sub-title>

                    <b-row>
                        <b-col cols="4">


                        </b-col>
                        <b-col cols="4">

                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 220 220"
                                width="256"
                                height="256"
                                preserveAspectRatio="none"
                            >
                                <defs>
                                    <linearGradient id="gradient1">
                                        <stop offset="0" style="stop-color:#1A75BB" />
                                        <stop offset="1" style="stop-color:#1A75BB" />
                                    </linearGradient>
                                </defs>
                                <ellipse
                                    ry="100" rx="100" cy="110" cx="110"
                                    style="fill:none;stroke:url(#gradient1);stroke-width:8;"
                                />
                                <text fill="black">
                                    <tspan :x="String(model.sensor.latest_value).length === 1 ? 92 : 75" y="133" style="font-size:64px">
                                        {{model.sensor.latest_value}}
                                    </tspan>
                                </text>
                            </svg>
                            <b-card-sub-title class="mt-3" style="font-size:1.66rem">Lastest Value</b-card-sub-title>

                        </b-col>

                        <b-col cols="4">

                        </b-col>
                    </b-row>

                    <b-row class="mt-3 mb-3">
                        <b-col/>
                        <b-col cols="4">

                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 220 220"
                                width="256"
                                height="256"
                                preserveAspectRatio="none"
                            >
                                <defs>
                                    <linearGradient id="gradient">
                                        <stop offset="0" style="stop-color:#000000" />
                                        <stop offset="0.6" style="stop-color:#1A75BB" />
                                    </linearGradient>
                                </defs>
                                <ellipse
                                    ry="100" rx="100" cy="110" cx="110"
                                    style="fill:none;stroke:url(#gradient);stroke-width:8;"
                                />
                                <text fill="black">
                                    <tspan :x="String(model.sensor.average_value).length === 1 ? 92 : 75" y="133" style="font-size:64px">
                                        {{model.sensor.average_value}}
                                    </tspan>
                                </text>
                            </svg>
                            <b-card-sub-title class="mt-3" style="font-size:1.66rem">Average Value</b-card-sub-title>

                        </b-col>

                        <b-col/>
                        <b-col cols="4">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 220 220"
                                width="256"
                                height="256"
                                preserveAspectRatio="none"
                            >
                                <defs>
                                    <linearGradient id="gradient2">
                                        <stop offset="0.4" style="stop-color:#1A75BB" />
                                        <stop offset="1" style="stop-color:#000000" />
                                    </linearGradient>
                                </defs>
                                <ellipse
                                    ry="100" rx="100" cy="110" cx="110"
                                    style="fill:none;stroke:url(#gradient2);stroke-width:8;"
                                />
                                <text fill="black">
                                    <tspan :x="String(model.sensor.latest_alert.value).length === 1 ? 95 : 72" y="122" style="font-size:56px">
                                        {{model.sensor.latest_alert.value}}
                                    </tspan>
                                    <tspan x="75" y="148">
                                        {{model.sensor.latest_alert.period}}
                                    </tspan>
                                </text>
                            </svg>
                            <b-card-sub-title
                                class="mt-3"
                                style="font-size:1.66rem"
                                v-b-tooltip.hover.bottom.html="{
                                    title: `It was a ${model.sensor.latest_alert.type} alert. <br/>
                                    ${model.sensor.latest_alert.status ? 'It remains active' : 'It is not active anymore.' }`
                                }"
                            >Last Alert</b-card-sub-title>

                        </b-col>
                        <b-col/>
                    </b-row>


                    <b-card-img src="/KonaMetrix_Black.png" alt="Image" bottom class="mt-5 mb-1"></b-card-img>
                    <a href="#" class="card-link">Upgrade Device</a>
                </b-card-body>


            </b-card>

        </b-container>
    </div>

</template>

<script>

    import { 
        device_requests, 
        sensor_requests, 
        update_device, 
        get_sensor_data, 
        get_alerts_by_sensor_id 
    } from '../../networking/devices'

    import moment from 'moment'
    export default {

        data(){
            return{
                nameEdit: false,
                edit_buttons_disabled: false,
                previous_device_name: null,
                model: {
                    device:{
                        id: null,
                        name: null,
                        device_type_desc: null,
                        service_plan: null,
                    },
                    sensor: {
                        sensor_id: null,
                        latest_value: null,
                        average_value: null,
                        latest_alert:{
                            value: ' ',
                            period: null,
                            type: null,
                            status: null
                        }
                    },
                }
            }
        },

        props:{
            userData:{
                type: Object,
                required: true
            }
        },

        async created(){

            const device_generator = device_requests.devicesByAccount({account_id: this.userData.accountId})
            const { value: { data: devices = [] } } = await device_generator.next()

            if(devices[0]){
                this.model = {
                    ...this.model, 
                    device: devices[0]
                }
                this.previous_device_name = devices[0].name
            }

            for (const device of devices) {
                const sensor_generator = sensor_requests.sensorsByDevice({ device_id: device.id})
                const { value: { data: sensors } } = await sensor_generator.next()
                device.sensors = sensors
            }

            if(devices[0] && devices[0].sensors && devices[0].sensors[0] && devices[0].sensors[0].podid){

                const message_generator = get_sensor_data(devices[0].sensors[0].podid)
                const { value: { data = {} } } = await message_generator.next()
                if(data && data.water_numbers){
                    const { water_numbers } = data
                    this.model.sensor = {
                        ...this.model.sensor,
                        latest_value: Math.round(water_numbers[0].value),
                        average_value: Math.round(water_numbers.map( i => i.value ).reduce((d, i) => d += i)/water_numbers.length)
                    }
                }

                const alert_generator = get_alerts_by_sensor_id(devices[0].sensors[0].podid)
                const { value: { data: alert_data = {} } } = await alert_generator.next()
                if(alert_data && alert_data[0] && alert_data[0].startDateTime){
                    const duration = moment(alert_data[0].startDateTime).fromNow().split(' ')
                    const alert_type = alert_data[0].alertType || ''
                    this.model.sensor.latest_alert = {
                        value: duration[0] !== 'a' ? duration[0] : ' 1', 
                        period: `${duration[1]} ${duration[2]}`,
                        type: alert_type.charAt(0).toUpperCase() + alert_type.slice(1).toLowerCase(),
                        status: alert_data[0].status !== 'CLOSED'
                    }
                }
            }
        },

        methods:{
            edit_name(bool){ this.nameEdit=bool },
            async save_name(body){
                this.edit_buttons_disabled = true
                const update_generator = update_device( this.model.device )
                const { value:{ data={}, alert={}} } = await update_generator.next()
                if(alert && alert.variant !== 'success'){ this.model.device.name = this.previous_device_name } 
                else { this.previous_device_name = this.model.device.name }
                this.edit_buttons_disabled = false
                this.edit_name(false)
            }
        }

    }
    
</script>

<style scoped>

    .card-img-top{
        height: 240px;
        object-fit: cover;
        object-position: 50% 24%;
        margin-left: 10%
    }

    .card-img-bottom{
        height: 72px;
        object-fit: contain
    }

</style>
